import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, apiError } from "@/lib/api";
import { useToast } from "@/context/ToastContext";
import { useAuth } from "@/context/AuthContext";
import { Loader, Currency, Field } from "@/components/Atoms";
import {
  Shield, Users, Crown, Coins, Settings, Wrench, Ban, ScrollText, Map as MapIcon,
  UserCog, Layers, Gift, PackageOpen, Server, Lock, KeyRound, Flame, Calendar,
  Flag, Sparkles, RefreshCw
} from "lucide-react";



export function Audit() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/admin/players/audit").then(({ data }) => setData(data)); }, []);
  const download = () => {
    const blob = new Blob([JSON.stringify(data, null, 2)], { type: "application/json" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a"); a.href = url; a.download = `audit-${Date.now()}.json`; a.click();
  };
  return (
    <div className="glass-card p-5 fade-up">
      <div className="flex items-center justify-between mb-3">
        <h3 className="label">Link Audit</h3>
        <button onClick={download} className="btn btn-sm" disabled={!data} data-testid="audit-download-button">Download JSON</button>
      </div>
      <p className="text-sm text-[var(--muted)] mb-3">{data?.total ?? "—"} link records.</p>
      <pre className="text-xs bg-black/40 rounded p-3 overflow-auto max-h-96">{JSON.stringify(data, null, 2)}</pre>
    </div>
  );
}
